/** 放送時間帯（朝・昼・夜） */
export const TV_BROADCAST_PERIODS = {
  MORNING: 'morning',
  NOON: 'noon',
  EVENING: 'evening',
};

export const TV_BROADCAST_PERIOD_OPTIONS = [
  { id: TV_BROADCAST_PERIODS.MORNING, label: '朝' },
  { id: TV_BROADCAST_PERIODS.NOON, label: '昼' },
  { id: TV_BROADCAST_PERIODS.EVENING, label: '夜' },
];

export const TV_BROADCAST_DEFAULT_PERIOD = TV_BROADCAST_PERIODS.MORNING;
